import { IParsedDo } from "../types";

export const getAccidental = (data: { _do: IParsedDo}) => {
    if (!data._do) {
        return 0;
    }
    let { value, alt } = data._do;
    while (value < 0) value += 7;
    value = value % 7;
    switch (value) {
        case 0:
            if (alt === 0) {
                return 5;
            }
            return -2;
        case 1:
            if (alt === 0) {
                return 0;
            } else if (alt === -1) {
                return -7;
            }
            return 7;
        case 2:
            if (alt === 0) {
                return 2;
            }
            return -5;
        case 3:
            if (alt === 0) {
                return 4;
            }
            return -3;
        case 4:
            if (alt === 0) {
                return -1;
            }
            return 6;
        case 5:
            if (alt === 0) {
                return 1;
            }
            return -6;
        case 6:
            if (alt === 0) {
                return 3;
            }
            return -4;
        default:
            return 0;
    }
};